export default "__VITE_PUBLIC_ASSET__346b377a__"